import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../../../services/app.service';
import { BcContestService } from '../../../services/bc-contest.service';

@Component({
    templateUrl: './bc-contest-submit.component.html',
    styleUrls: ['../bc-contest.scss']
})
export class BcContestSubmitComponent {
    constructor(
        private app: AppService,
        private service: BcContestService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() contestId: number;
    @Input() program: string;

    isSubmitting: boolean;

    submit() {
        this.isSubmitting = true;

        setTimeout(() => {
            this.service.submit(this.contestId, this.program ? [this.program] : undefined).subscribe(() => {
                this.activeModal.close(true);
            }, err => {
                this.app.showError(err);
                this.activeModal.close(false);
            });
        }, 500);
    }

    close() {
        this.activeModal.dismiss();
    }
}
